import { BaseRepository } from './BaseRepository';
import { getDatabase, NexxusDatabase } from './NexxusDatabase';
import type { CentreAnalytique } from '@shared/types/CentreAnalytique';

export class CentreAnalytiqueRepository extends BaseRepository<CentreAnalytique> {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).centres_analytiques);
  }
}
